export const MOCK_ENTREPRISES = [
  {
    id: 'ent-001',
    nom: 'TLG PHARMA',
    initiales: 'TL',
    couleur: '#0891B2',
    secteur: 'Pharmaceutique',
    email_contact: 'contact@tlgpharma.ci',
    telephone: '+225 27 20 31 00 00',
    adresse: 'Plateau, Avenue Noguès',
    ville: 'Abidjan',
    pays: 'Côte d\'Ivoire',
    responsable: 'Dr. Koné Thierry',
    nb_beneficiaires_contrat: 30,
    nb_beneficiaires_actifs: 22,
    package: 'Premium',
    ca_contrat: 5500000,
    devise: 'FCFA',
    date_debut_contrat: '2025-01-01',
    date_fin_contrat: '2026-12-31',
    statut: 'actif',
    renouvellement_auto: true,
    option_replay: true,
    types_sessions: ['presentiel', 'ligne'],
    notes: 'Programme phare BET - enfants & adolescents du personnel',
  },
  {
    id: 'ent-002',
    nom: 'ORANGE CI',
    initiales: 'OC',
    couleur: '#F97316',
    secteur: 'Télécommunications',
    email_contact: 'rh@orange.ci',
    telephone: '+225 27 20 00 00 00',
    adresse: 'Boulevard de la Paix',
    ville: 'Abidjan',
    pays: 'Côte d\'Ivoire',
    responsable: 'Diallo Aminata',
    nb_beneficiaires_contrat: 50,
    nb_beneficiaires_actifs: 48,
    package: 'Enterprise',
    ca_contrat: 9200000,
    devise: 'FCFA',
    date_debut_contrat: '2025-03-01',
    date_fin_contrat: '2026-02-28',
    statut: 'actif',
    renouvellement_auto: false,
    option_replay: true,
    types_sessions: ['ligne'],
    notes: 'Formation adultes - équipes commerciales et support',
  },
  {
    id: 'ent-003',
    nom: 'SGBCI',
    initiales: 'SG',
    couleur: '#DC2626',
    secteur: 'Banque & Finance',
    email_contact: 'formation@sgbci.ci',
    telephone: '+225 27 20 20 10 00',
    adresse: 'Avenue du Général de Gaulle, Plateau',
    ville: 'Abidjan',
    pays: 'Côte d\'Ivoire',
    responsable: 'Ouattara Bamba',
    nb_beneficiaires_contrat: 20,
    nb_beneficiaires_actifs: 18,
    package: 'Business',
    ca_contrat: 3800000,
    devise: 'FCFA',
    date_debut_contrat: '2025-06-01',
    date_fin_contrat: '2025-11-30',
    statut: 'expire_bientot',
    renouvellement_auto: false,
    types_sessions: ['presentiel'],
    notes: 'Contrat expire dans 30 jours - relancer le responsable',
  },
  {
    id: 'ent-004',
    nom: 'CANAL+ AFRIQUE',
    initiales: 'CA',
    couleur: '#8B5CF6',
    secteur: 'Médias & Divertissement',
    email_contact: 'drh@canalplus-afrique.com',
    telephone: '+225 27 22 40 00 00',
    adresse: 'Marcory Zone 4',
    ville: 'Abidjan',
    pays: 'Côte d\'Ivoire',
    responsable: 'Traoré Fatoumata',
    nb_beneficiaires_contrat: 15,
    nb_beneficiaires_actifs: 15,
    package: 'Business',
    ca_contrat: 2850000,
    devise: 'FCFA',
    date_debut_contrat: '2025-09-01',
    date_fin_contrat: '2026-08-31',
    statut: 'actif',
    renouvellement_auto: true,
    types_sessions: ['ligne'],
    notes: '',
  },
  {
    id: 'ent-005',
    nom: 'NSIA BANQUE',
    initiales: 'NB',
    couleur: '#059669',
    secteur: 'Banque & Finance',
    email_contact: 'formation@nsia.ci',
    telephone: '+225 27 20 22 40 00',
    adresse: 'Rue des Jardins, Cocody',
    ville: 'Abidjan',
    pays: 'Côte d\'Ivoire',
    responsable: 'Sanogo Issa',
    nb_beneficiaires_contrat: 25,
    nb_beneficiaires_actifs: 10,
    package: 'Business',
    ca_contrat: 4750000,
    devise: 'FCFA',
    date_debut_contrat: '2025-10-01',
    date_fin_contrat: '2026-09-30',
    statut: 'actif',
    renouvellement_auto: false,
    types_sessions: ['presentiel'],
    notes: 'Onboarding en cours - 15 bénéficiaires en attente de test',
  },
  {
    id: 'ent-006',
    nom: 'ECOBANK CI',
    initiales: 'EB',
    couleur: '#0E7490',
    secteur: 'Banque & Finance',
    email_contact: 'rh@ecobank.com',
    telephone: '+225 27 20 31 92 00',
    adresse: 'Avenue Terrasson de Fougères',
    ville: 'Abidjan',
    pays: 'Côte d\'Ivoire',
    responsable: 'Coulibaly Mariam',
    nb_beneficiaires_contrat: 40,
    nb_beneficiaires_actifs: 0,
    package: 'Enterprise',
    ca_contrat: 7600000,
    devise: 'FCFA',
    date_debut_contrat: '2026-01-01',
    date_fin_contrat: '2026-12-31',
    statut: 'prospect',
    renouvellement_auto: false,
    types_sessions: ['ligne'],
    notes: 'Devis signé - démarrage prévu janvier 2026',
  },
];

export const MOCK_BENEFICIAIRES_ENTREPRISE = [
  // TLG PHARMA
  { id: 'be-001', entreprise_id: 'ent-001', prenom: 'Léa',     nom: 'Koné',     email: 'lea.kone@tlgpharma.ci',     poste: 'Pharmacienne',          niveau_cecr: 'B1', statut: 'actif',    date_inscription: '2025-01-15' },
  { id: 'be-002', entreprise_id: 'ent-001', prenom: 'Marc',    nom: 'Touré',    email: 'marc.toure@tlgpharma.ci',    poste: 'Délégué médical',       niveau_cecr: 'A2', statut: 'actif',    date_inscription: '2025-01-15' },
  { id: 'be-003', entreprise_id: 'ent-001', prenom: 'Awa',     nom: 'Diabaté',  email: 'awa.diabate@tlgpharma.ci',   poste: 'Assistante RH',         niveau_cecr: 'B2', statut: 'certifie', date_inscription: '2025-01-20' },
  { id: 'be-004', entreprise_id: 'ent-001', prenom: 'Yves',    nom: 'Brou',     email: 'yves.brou@tlgpharma.ci',     poste: 'Responsable logistique',niveau_cecr: 'A1', statut: 'en_attente',date_inscription: '2025-03-01'},
  // ORANGE CI
  { id: 'be-005', entreprise_id: 'ent-002', prenom: 'Fatou',   nom: 'Camara',   email: 'fatou.camara@orange.ci',     poste: 'Conseillère commerciale',niveau_cecr: 'B1',statut: 'actif',    date_inscription: '2025-03-10' },
  { id: 'be-006', entreprise_id: 'ent-002', prenom: 'Seydou',  nom: 'Traoré',   email: 'seydou.traore@orange.ci',    poste: 'Technicien réseau',     niveau_cecr: 'A2', statut: 'actif',    date_inscription: '2025-03-10' },
  { id: 'be-007', entreprise_id: 'ent-002', prenom: 'Hawa',    nom: 'Kouyaté',  email: 'hawa.kouyate@orange.ci',     poste: 'Manager support',       niveau_cecr: 'B2', statut: 'actif',    date_inscription: '2025-04-01' },
  // SGBCI
  { id: 'be-008', entreprise_id: 'ent-003', prenom: 'Ibrahim', nom: 'Sanogo',   email: 'ibrahim.sanogo@sgbci.ci',    poste: 'Chargé de clientèle',   niveau_cecr: 'B1', statut: 'actif',    date_inscription: '2025-06-05' },
  { id: 'be-009', entreprise_id: 'ent-003', prenom: 'Aïcha',   nom: 'Bamba',    email: 'aicha.bamba@sgbci.ci',       poste: 'Analyste financière',   niveau_cecr: 'B2', statut: 'certifie', date_inscription: '2025-06-05' },
  // CANAL+
  { id: 'be-010', entreprise_id: 'ent-004', prenom: 'Daouda',  nom: 'Fofana',   email: 'daouda.fofana@canalplus.com',poste: 'Journaliste',           niveau_cecr: 'C1', statut: 'actif',    date_inscription: '2025-09-05' },
  { id: 'be-011', entreprise_id: 'ent-004', prenom: 'Nadia',   nom: 'Koné',     email: 'nadia.kone@canalplus.com',   poste: 'Productrice',           niveau_cecr: 'B2', statut: 'actif',    date_inscription: '2025-09-05' },
  // NSIA
  { id: 'be-012', entreprise_id: 'ent-005', prenom: 'Cheick',  nom: 'Doumbia',  email: 'cheick.doumbia@nsia.ci',     poste: 'Directeur agence',      niveau_cecr: null, statut: 'en_attente',date_inscription: '2025-10-05'},
  { id: 'be-013', entreprise_id: 'ent-005', prenom: 'Rokia',   nom: 'Sidibé',   email: 'rokia.sidibe@nsia.ci',       poste: 'Responsable compliance', niveau_cecr: 'A2',statut: 'actif',    date_inscription: '2025-10-10' },
];

export const MOCK_CONTRATS = [
  {
    id: 'ct-001', entreprise_id: 'ent-001', entreprise_nom: 'TLG PHARMA',
    reference: 'CT-2025-001', package: 'Premium',
    nb_beneficiaires: 30, tarif_par_beneficiaire: 183333,
    montant_total: 5500000, devise: 'FCFA',
    date_signature: '2024-12-15',
    date_debut: '2025-01-01', date_fin: '2026-12-31',
    statut: 'actif', renouvellement_auto: true,
    modalite_paiement: 'Trimestrielle',
    acompte_verse: 2750000,
    solde_restant: 2750000,
  },
  {
    id: 'ct-002', entreprise_id: 'ent-002', entreprise_nom: 'ORANGE CI',
    reference: 'CT-2025-002', package: 'Enterprise',
    nb_beneficiaires: 50, tarif_par_beneficiaire: 184000,
    montant_total: 9200000, devise: 'FCFA',
    date_signature: '2025-02-10',
    date_debut: '2025-03-01', date_fin: '2026-02-28',
    statut: 'actif', renouvellement_auto: false,
    modalite_paiement: 'Semestrielle',
    acompte_verse: 9200000,
    solde_restant: 0,
  },
  {
    id: 'ct-003', entreprise_id: 'ent-003', entreprise_nom: 'SGBCI',
    reference: 'CT-2025-003', package: 'Business',
    nb_beneficiaires: 20, tarif_par_beneficiaire: 190000,
    montant_total: 3800000, devise: 'FCFA',
    date_signature: '2025-05-20',
    date_debut: '2025-06-01', date_fin: '2025-11-30',
    statut: 'expire_bientot', renouvellement_auto: false,
    modalite_paiement: 'Annuelle',
    acompte_verse: 3800000,
    solde_restant: 0,
  },
  {
    id: 'ct-004', entreprise_id: 'ent-004', entreprise_nom: 'CANAL+ AFRIQUE',
    reference: 'CT-2025-004', package: 'Business',
    nb_beneficiaires: 15, tarif_par_beneficiaire: 190000,
    montant_total: 2850000, devise: 'FCFA',
    date_signature: '2025-08-15',
    date_debut: '2025-09-01', date_fin: '2026-08-31',
    statut: 'actif', renouvellement_auto: true,
    modalite_paiement: 'Annuelle',
    acompte_verse: 2850000,
    solde_restant: 0,
  },
  {
    id: 'ct-005', entreprise_id: 'ent-005', entreprise_nom: 'NSIA BANQUE',
    reference: 'CT-2025-005', package: 'Business',
    nb_beneficiaires: 25, tarif_par_beneficiaire: 190000,
    montant_total: 4750000, devise: 'FCFA',
    date_signature: '2025-09-25',
    date_debut: '2025-10-01', date_fin: '2026-09-30',
    statut: 'actif', renouvellement_auto: false,
    modalite_paiement: 'Trimestrielle',
    acompte_verse: 2375000,
    solde_restant: 2375000,
  },
];

export const MOCK_PAIEMENTS = [
  // TLG PHARMA (ent-001) - contrat 5 500 000 FCFA - trimestriel
  { id: 'pai-001', entreprise_id: 'ent-001', montant: 2750000, date: '2025-01-10', mode: 'Virement bancaire', reference: 'VIR-2501-001', statut: 'recu', note: 'Acompte 50% à la signature' },
  { id: 'pai-002', entreprise_id: 'ent-001', montant: 916667,  date: '2025-04-02', mode: 'Chèque',           reference: 'CHQ-2502-001', statut: 'recu', note: 'Échéance T2 2025' },
  { id: 'pai-003', entreprise_id: 'ent-001', montant: 916667,  date: '2025-07-05', mode: 'Virement bancaire', reference: 'VIR-2503-001', statut: 'recu', note: 'Échéance T3 2025' },
  { id: 'pai-004', entreprise_id: 'ent-001', montant: 916666,  date: '2025-10-01', mode: 'Virement bancaire', reference: 'VIR-2504-001', statut: 'en_attente', note: 'Échéance T4 2025 - en cours' },

  // ORANGE CI (ent-002) - contrat 9 200 000 FCFA - semestriel - soldé
  { id: 'pai-005', entreprise_id: 'ent-002', montant: 4600000, date: '2025-02-15', mode: 'Virement bancaire', reference: 'VIR-2501-002', statut: 'recu', note: 'Première moitié du contrat' },
  { id: 'pai-006', entreprise_id: 'ent-002', montant: 4600000, date: '2025-08-20', mode: 'Virement bancaire', reference: 'VIR-2502-002', statut: 'recu', note: 'Seconde moitié - solde' },

  // SGBCI (ent-003) - contrat 3 800 000 FCFA - annuel - soldé
  { id: 'pai-007', entreprise_id: 'ent-003', montant: 3800000, date: '2025-05-25', mode: 'Chèque de banque', reference: 'CHQ-2501-003', statut: 'recu', note: 'Paiement intégral annuel' },

  // CANAL+ (ent-004) - contrat 2 850 000 FCFA - annuel - soldé
  { id: 'pai-008', entreprise_id: 'ent-004', montant: 2850000, date: '2025-08-20', mode: 'Virement bancaire', reference: 'VIR-2501-004', statut: 'recu', note: 'Règlement complet' },

  // NSIA (ent-005) - contrat 4 750 000 FCFA - trimestriel - acompte versé
  { id: 'pai-009', entreprise_id: 'ent-005', montant: 2375000, date: '2025-10-03', mode: 'Virement bancaire', reference: 'VIR-2501-005', statut: 'recu', note: 'Acompte 50% ouverture de compte' },
];

export const MOCK_ECHEANCIERS = [
  // TLG PHARMA - 4 échéances trimestrielles (restant: 916 666 FCFA)
  { id: 'ech-001', entreprise_id: 'ent-001', num: 1, libelle: 'Acompte signature', montant: 2750000, date_prevue: '2025-01-10', statut: 'paye',       date_paiement: '2025-01-10' },
  { id: 'ech-002', entreprise_id: 'ent-001', num: 2, libelle: 'Échéance T2',       montant: 916667,  date_prevue: '2025-04-01', statut: 'paye',       date_paiement: '2025-04-02' },
  { id: 'ech-003', entreprise_id: 'ent-001', num: 3, libelle: 'Échéance T3',       montant: 916667,  date_prevue: '2025-07-01', statut: 'paye',       date_paiement: '2025-07-05' },
  { id: 'ech-004', entreprise_id: 'ent-001', num: 4, libelle: 'Échéance T4',       montant: 916666,  date_prevue: '2025-10-01', statut: 'en_attente', date_paiement: null },

  // ORANGE CI - 2 versements semestriels (soldé)
  { id: 'ech-005', entreprise_id: 'ent-002', num: 1, libelle: '1er semestre',      montant: 4600000, date_prevue: '2025-02-15', statut: 'paye',       date_paiement: '2025-02-15' },
  { id: 'ech-006', entreprise_id: 'ent-002', num: 2, libelle: '2e semestre',       montant: 4600000, date_prevue: '2025-08-15', statut: 'paye',       date_paiement: '2025-08-20' },

  // SGBCI - annuel (soldé)
  { id: 'ech-007', entreprise_id: 'ent-003', num: 1, libelle: 'Paiement annuel',   montant: 3800000, date_prevue: '2025-06-01', statut: 'paye',       date_paiement: '2025-05-25' },

  // CANAL+ - annuel (soldé)
  { id: 'ech-008', entreprise_id: 'ent-004', num: 1, libelle: 'Paiement annuel',   montant: 2850000, date_prevue: '2025-09-01', statut: 'paye',       date_paiement: '2025-08-20' },

  // NSIA - 4 trimestres (acompte versé, 3 restants)
  { id: 'ech-009', entreprise_id: 'ent-005', num: 1, libelle: 'Acompte ouverture', montant: 2375000, date_prevue: '2025-10-01', statut: 'paye',       date_paiement: '2025-10-03' },
  { id: 'ech-010', entreprise_id: 'ent-005', num: 2, libelle: 'Échéance T2',       montant: 791667,  date_prevue: '2026-01-01', statut: 'en_attente', date_paiement: null },
  { id: 'ech-011', entreprise_id: 'ent-005', num: 3, libelle: 'Échéance T3',       montant: 791667,  date_prevue: '2026-04-01', statut: 'a_venir',    date_paiement: null },
  { id: 'ech-012', entreprise_id: 'ent-005', num: 4, libelle: 'Solde final',       montant: 791666,  date_prevue: '2026-07-01', statut: 'a_venir',    date_paiement: null },
];

export const PACKAGES = [
  { id: 'starter',    libelle: 'Starter',    max_benef: 10,  tarif: 200000, couleur: '#94A3B8' },
  { id: 'business',   libelle: 'Business',   max_benef: 25,  tarif: 190000, couleur: '#0891B2' },
  { id: 'premium',    libelle: 'Premium',    max_benef: 50,  tarif: 183333, couleur: '#8B5CF6' },
  { id: 'enterprise', libelle: 'Enterprise', max_benef: 999, tarif: 184000, couleur: '#F97316' },
];

export const SECTEURS = [
  'Pharmaceutique', 'Télécommunications', 'Banque & Finance',
  'Médias & Divertissement', 'Assurance', 'Industrie', 'Commerce',
  'Éducation', 'Santé', 'Technologie', 'Autre',
];
